import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import { getCycleDetail } from "../requests/cycles.requests";

export const useGetCycleDetail = (cycleUuid: string | null | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CYCLE_DETAIL, cycleUuid],
    queryFn: () => getCycleDetail(cycleUuid as string),
    enabled: !!cycleUuid,
    staleTime: 5 * 60_000,
  });
};
